export default "__VITE_ASSET__93f2ad04__"